export default __webpack_public_path__ + "static/media/nulla.13bc8254.svg";